import { IconButton, SvgIcon } from "@mui/material"
import { useAlert } from "components/Alerts/hooks"
import { alerts } from "keys"
import { ReactComponent as CodeIcon } from 'assets/icons/Code.svg';


const useGenerateCouponCode = () => {
    const { setAlerts } = useAlert()

    const openCouponAlert = () => {
        setAlerts(alerts.createCoupon, true)
    }

    const generateCouponCodeBtn = {
        id: 0,
        label: "צור קוד קופון",
        name: "report",
        action: openCouponAlert,
        component: "button",
        height: "35px",
        icon: <SvgIcon component={CodeIcon} inheritViewBox />,
        color: "rating5",
        disabledColor: 'rating4',

        feature: "generate-coupon-code",//TODO move to json features
        role: "create",
        permissionHOC: "hidden",
    }

    return generateCouponCodeBtn
}

export default useGenerateCouponCode